import './email-verify.css'
import google_logo from '../../assets/google_logo.webp'
import Icon from '@mdi/react';
import { mdiAlertCircleOutline, mdiEye, mdiEyeClosed } from '@mdi/js'
import { useEffect, useState } from 'react'
import {API_BASE_URL} from '../../global.js'
import { useNavigate } from "react-router-dom";

export default function EmailVerify({isAuth, setIsAuth}) {

    const navigate = useNavigate();
    useEffect(() => {
        const auth = localStorage.getItem("auth");
        if (auth === "false") {
            navigate('/Autenticacao')
        }else if (auth === "true"){
            const verified = localStorage.getItem("verificado");
            if (verified === "true") {
                navigate('/')
            }
        }
    }, []);

    const [codigo, setCodigo] = useState('');

    const [erro, setErro] = useState(false);
    const [erroMsg, setErroMsg] = useState('');

    const [cooldown, setCooldown] = useState(0);
    const [reenviando, setReenviando] = useState(false);

    useEffect(() => {
        let timer;
        if (cooldown > 0) {
            timer = setTimeout(() => setCooldown(cooldown - 1), 1000);
        }
        return () => clearTimeout(timer);
    }, [cooldown]);

    const reenviarEmail = async () => {
        if (cooldown > 0 || reenviando) return;
        setReenviando(true);
        try {
            const response = await fetch(`${API_BASE_URL}/auth/reenviar_email.php`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'include'
            });
            const data = await response.json();
            if (data.status === 'success') {
                setCooldown(60);
            } else {
                setErro(true);
                setErroMsg(data.msg || "Erro ao reenviar e-mail");
            }
        } catch (error) {
            console.log('Erro de conexão:', error);
        }
        setReenviando(false);
    }

    const verificarEmail = async () => {

        if(codigo === ''){
            setErro(true); 
            setErroMsg("Campo 'Código' não pode ficar em branco");
            return;
        } 
        
        if(codigo.length < 6){
            setErro(true); 
            setErroMsg("Código inválido");
            return;
        } 
        
        try {
            const response = await fetch(`${API_BASE_URL}/auth/email_verify.php`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials:'include',
                body:JSON.stringify({
                    codigo:codigo
                })
            });

            const data = await response.json();   
            if(data.status === 'success'){
                localStorage.setItem("verificado", "true");
                navigate('/');
            }else{
                localStorage.setItem("verificado", "false");
                setErro(true); 
                setErroMsg(data.msg);
            }
           
        } catch (error) {
            console.log('Erro de conexão:', error);
        }
    }

    const handleCodigo = (value) => {
        const somenteNumeros = value.replace(/\D/g, '').slice(0, 6);
        setCodigo(somenteNumeros);
    }


    return(
        <div className="email_verify_body">
            <div className='email_verify_box-email_verify'>
                <div className='email_verify_title'>
                    <h1>Verificação de E-mail</h1>
                    <p>Um e-mail com um código de verificação foi enviado.</p>
                </div>

                {erro &&
                    <div className='error-msg'>
                        <p><Icon path={mdiAlertCircleOutline} size={0.75} />{erroMsg}</p>
                    </div>}
                

                <section className='group_default-email_verify'>
                    <div className='auth-input-group_default'>
                        <label for=''>Código</label>
                        <input type='text' value={codigo} onChange={(e) => handleCodigo(e.target.value)} placeholder='Insira o código'></input>
                    </div>                  

                    <button 
                        className='resend-btn' 
                        onClick={reenviarEmail} 
                        disabled={cooldown > 0 || reenviando}
                    >
                        {reenviando ? 'Enviando...' : cooldown > 0 ? `Aguarde ${cooldown}s para reenviar` : 'Reenviar E-mail'}
                    </button>

                    <button onClick={()=>verificarEmail()}>Concluir</button>
                </section>

            </div>
        </div>
    )
}